import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';

import { environment } from '@environment';

@Injectable({
    providedIn: 'root'
})
export class SeoService {
    constructor(private meta: Meta) {}

    generateTags(config) {
        // twitter

        this.meta.updateTag({
            name: 'twitter:card',
            content: 'summary_large_image'
        });

        this.meta.updateTag({
            name: 'twitter:site',
            content: `@${environment.links.share.twitter.handle}`
        });

        for (const [key, value] of Object.entries(config)) {
            this.meta.updateTag({
                name: `twitter:${key}`,
                content: value as string
            });
        }

        // open graph

        this.meta.updateTag({
            property: 'og:type',
            content: 'website'
        });

        this.meta.updateTag({
            property: 'og:site_name',
            content: environment.brand.name
        });

        for (const [key, value] of Object.entries(config)) {
            this.meta.updateTag({
                property: `og:${key}`,
                content: value as string
            });
        }

        this.meta.updateTag({
            property: 'og:url',
            content: environment.brand.url
        });
    }
}
